module.exports = __webpack_public_path__ + "static/img/1526551582957827911.82fdaff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/category/1526551582957827911.jpg
// module id = hKsr
// module chunks = 0